import React, { useContext } from 'react'
import {
    ConnectPayouts,
    ConnectComponentsProvider,
} from '@stripe/react-connect-js';
import { Box, Text } from "@chakra-ui/react";
import { useAccountSession } from '../../hooks/useAccountSession';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { OnboardingSteps } from '../../components/OnboardingSteps';
import { LoadingOverlay } from '../../components/LoadingOverlay';
import { HelmetComponent } from '../../components/HelmetComponent';

export const StripePayoutPage = () => {

    const { user, publisher } = useContext(PublisherAndUserContext);

    const {
        stripeConnectInstance,
        createStripeConnectedAccount,
        createStripeConnectedAccountLink,
        loading
    } = useAccountSession({ user, accountId: publisher.stripeAccountId, component: "payouts", publisherId: publisher.id })

    return (
        <>
            <HelmetComponent title={`Payouts - Home - ${user.firstName} ${user.lastName}`}/>
            {loading && <LoadingOverlay />}
            {
                publisher?.otherInfo?.isOnBoardingCompleted && publisher?.otherInfo?.isStoreSettingComplete ?
                    <Box m={"5px 0"} p={"10px"} background="#fff" borderRadius={"10px"} boxShadow={"0 3px 6px rgba(27, 110, 194, 0.3), 0 3px 6px rgba(27, 110, 194, 0.3)"}>
                        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                            <ConnectPayouts />
                        </ConnectComponentsProvider>
                    </Box> :
                    <>
                        <Text color="orange.600" p={6} >Please finish the onboarding first to get started with payouts.</Text>
                        <OnboardingSteps onboarding={publisher?.stripeAccountId ? createStripeConnectedAccountLink : createStripeConnectedAccount} stripeOnboardingUrl={publisher?.stripeOnboardingUrl} publisher={publisher}/>
                    </>
            }
        </>
    )
}
